import App from './src/App'
import Sidebar from './src/Sidebar'
import Subbar from './src/Subbar'
import Darkmode from './src/Darkmode'
import Footer from './src/Footer'

//Components
import TestCard from './src/components/TestCard'
import ControlCard from './src/components/ControlCard'

//Pages
import Premium from './src/pages/Premium'
import './src/common/directives'

export default {
    install(Vue, options) {
        Vue.component('appcomponent', App)
        Vue.component('sidebarcomponent', Sidebar)
        Vue.component('subbarcomponent', Subbar)
        Vue.component('darkmodecomponent', Darkmode)
        Vue.component('footercomponent', Footer)
        Vue.component('testcard', TestCard)
        Vue.component('controlcard', ControlCard)
        Vue.component('premiumpage', Premium)

        // Vue.prototype.$settingspage = {
           
        // }
    }
}
